import StarIcon from '../icons/StarIcon';
import GroupPersonsIcon from '../icons/GroupPersonsIcon';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PdfIcon from '../icons/PdfIcon';
import DocIcon from '../icons/DocIcon';

export const MainData = {
    heading: 'AJG Holdings, LLC',
    para: 'Conveniently access all of your business details and important business documents.',
};
export const KeyPointsDetails = {
    heading: 'Data Points',
    list: [
        {
            icon: <StarIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <GroupPersonsIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <MailOutlineIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <StarIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <StarIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <StarIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
        {
            icon: <StarIcon />,
            para1: 'Company Name',
            para2: 'Appleton Co, LLC',
        },
    ],
};

export const COMPANY_RELATED_DETAILS = [
    {
        name: 'Company Name',
        value: 'Appleton Co, LLC',
    },
    {
        name: 'Employer Identification Number (EIN)',
        value: '5-40393900',
    },
    {
        name: 'State of Incorporation',
        value: 'Delaware',
    },
    {
        name: 'State Registration ID',
        value: '7291487-122',
    },
    {
        name: 'Date of Incorporation',
        value: 'September 1, 2015',
    },
    {
        name: 'Registered Agent',
        value: 'Prime Corporate Services',
    },
];

export const ADDITIONAL_LIST = [
    {
        name: 'Dissolve this entity',
    },
    {
        name: 'Amend Entity',
    },
    {
        name: 'Add DBA',
    },
    {
        name: 'Billing History',
    },
    {
        name: 'View Registered Agent Mail',
    },
];

export const MEMBER_DETAILS = {
    name: 'Members',
    list: [
        {
            p1: 'Aaron Gunderson',
            invited: false,
        },
        {
            p1: 'Jesse Himsworth',
            invited: true,
        },
        {
            p1: 'Steven Lutsky',
            invited: false,
        },
        {
            p1: 'Gustavo Melendez',
            invited: true,
        },
    ],
};

export const BusinessDocumentsDetails = {
    heading: 'Business Documents',
    list: [],
};
export const CorporatePdfList = [
    {
        para1: 'Articles of Incorporation',
        para2: '200 KB | pdf',
        icon: <PdfIcon />,
    },
    {
        para1: 'State Filing',
        para2: '340 KB | docx',
        icon: <DocIcon />,
    },
    {
        para1: 'Federal EIN Registration',
        para2: '40 KB | pdf',
        icon: <PdfIcon />,
    },
];

export const TabList = [
    {
        label: 'Corporate Documents',
        value: 1,
    },
    {
        label: 'Insurance Documents',
        value: 2,
    },
    {
        label: 'Tax Documents',
        value: 3,
    },
];
